import { REACT_APP_OLE_APIS } from '../../config';
import { uuidv4 } from 'services/common';
import * as Sentry from '@sentry/react';

const registerAgenda = async (data:AgendaRequest): Promise<any> => {
    try {
      const response = await fetch(`${REACT_APP_OLE_APIS}/api-client/quote-form-scheduling`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-User': 'web',
          'X-Request-ID': uuidv4()
        },
        body: JSON.stringify(data)
      });
      if (!response.ok) {
        Sentry.logger.error('agendaService[registerAgenda] error', { status: response.status, message: await response.text() });
        throw new Error('Error fetching register agenda');
      }
      const contentType = response.headers.get('content-type') || '';
      const body = contentType.includes('application/json')
      ? await response.json()
      : await response.text();
      //const r = await response.json();
      Sentry.logger.info('agendaService[registerAgenda]', { response: body });
      return body;
    } catch (error) {
      Sentry.logger.error('agendaService[registerAgenda] unexpected error', { error: error });
      console.error('[register agenda]', error);
      throw error;
    }
};

export { registerAgenda };